export default __webpack_public_path__ + "static/media/no-selected-chat.75f737d5.png";